import { createAsyncThunk } from "@reduxjs/toolkit";
import * as maintenanceApi from '../../utils/api/maintenanceApi';


export const fetchMaintenance = createAsyncThunk(
    'maintenance/fetchMaintenance',
    async(_, {rejectWithValue}) => {
        try {
            return await maintenanceApi.fetchMaintenance();
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)